<!-- Estimated Erollment Timeframe -->
<div class="accordion-item">
    <p class="accordion-header">
        <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#progInfoCollapse1'">{{'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.HEADER'| translate}}</button>									
    </p>

    <div id="progInfoCollapse1" class="accordion-collapse collapse" data-bs-parent="#prog-info-accordion">
        <div class="card-body">
            <p>{{'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION1.INTRO' | translate}}</p>
            <ul>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION1.LIST1.0' | translate" ></li>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION1.LIST1.1' | translate" ></li>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION1.LIST1.2' | translate" ></li>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION1.LIST1.3' | translate" ></li>
            </ul> 
            
            <p><span [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION2' | translate"></span></p>
            <p><span [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION3' | translate"></span></p>

            <p><span [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION4.INTRO' | translate"></span></p>
            <ul>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION4.LIST1.0' | translate" ></li>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.0.BODY.SECTION4.LIST1.1' | translate" ></li>
            </ul> 
        </div>
    </div>
</div>

<!-- Enrollment Centers-->
<div class="accordion-item">
    <p class="accordion-header">
        <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#progInfoCollapse2'">{{'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.1.HEADER'| translate}}</button>									
    </p>

    <div id="progInfoCollapse2" class="accordion-collapse collapse" data-bs-parent="#prog-info-accordion">
        <div class="card-body">
            <span [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.1.BODY.SECTION1' | translate"></span>
        </div>
    </div>
</div>

<!-- Required Documentation -->
<div class="accordion-item">
    <p class="accordion-header">
        <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#progInfoCollapse3'">{{'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.2.HEADER'| translate}}</button>									
    </p>

    <div id="progInfoCollapse3" class="accordion-collapse collapse" data-bs-parent="#prog-info-accordion">
        <div class="card-body">
            <span [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.2.BODY.SECTION1.INTRO' | translate"></span>
            <ul>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.2.BODY.SECTION1.LIST1.0' | translate" ></li>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.2.BODY.SECTION1.LIST1.1' | translate" ></li>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.2.BODY.SECTION1.LIST1.2' | translate" ></li>
            </ul> 
        </div>
    </div>
</div>

<!-- Reasons for Membership Delay or Denial -->
<div class="accordion-item">
    <p class="accordion-header">
        <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#progInfoCollapse4'">{{'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.3.HEADER'| translate}}</button>									
    </p>

    <div id="progInfoCollapse4" class="accordion-collapse collapse" data-bs-parent="#prog-info-accordion">
        <div class="card-body">
            <span [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.3.BODY.SECTION1.INTRO' | translate"></span>
            <ul>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.3.BODY.SECTION1.LIST1.0' | translate" ></li>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.3.BODY.SECTION1.LIST1.1' | translate" ></li>
                <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.3.BODY.SECTION1.LIST1.2' | translate" ></li>
            </ul>
            <p [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.3.BODY.SECTION2' | translate"></p>
        </div>
    </div>
</div>

<!-- Membership Eligibility for Adults and Minors -->
<div class="accordion-item">
    <p class="accordion-header">
        <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#progInfoCollapse5'">{{'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.HEADER'| translate}}</button>									
    </p>

    <div id="progInfoCollapse5" class="accordion-collapse collapse" data-bs-parent="#prog-info-accordion">
        <div class="card-body">
            <p [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION1' | translate"></p>

            <div>
                <span [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION2.INTRO' | translate"></span>
                <ul>
                    <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION2.LIST1.0' | translate" ></li>
                    <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION2.LIST1.1' | translate" ></li>
                    <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION2.LIST1.2' | translate" ></li>
                    <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION2.LIST1.3' | translate" ></li>
                    <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION2.LIST1.4' | translate" ></li>
                    <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION2.LIST1.5' | translate" ></li>
                    <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION2.LIST1.6' | translate" ></li>
                    <li [innerHTML]="'PROGRAM_LANDING_PAGE.NH.WHAT_TO_KNOW.4.BODY.SECTION2.LIST1.7' | translate" ></li>
                </ul>
            </div>
        </div>
    </div>
</div>
